'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _AddReactionButton = require('../AddReactionButton');

var _AddReactionButton2 = _interopRequireDefault(_AddReactionButton);

var _AddReactionPopup = require('../AddReactionPopup');

var _AddReactionPopup2 = _interopRequireDefault(_AddReactionPopup);

var _actionCreators = require('../../../store/actions/action-creators');

var _logValues = require('../../../shared/logging/log-values');

var _adTrackingUtil = require('../../../utils/ad-tracking-util');

var _adTrackingUtil2 = _interopRequireDefault(_adTrackingUtil);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ConnectedAddReaction = function (_Component) {
  _inherits(ConnectedAddReaction, _Component);

  function ConnectedAddReaction(props) {
    _classCallCheck(this, ConnectedAddReaction);

    var _this = _possibleConstructorReturn(this, (ConnectedAddReaction.__proto__ || Object.getPrototypeOf(ConnectedAddReaction)).call(this, props));

    _this.onOpenPopup = function () {
      var showAddReactionPopup = !_this.state.showAddReactionPopup;

      _this.setState({
        showAddReactionPopup: showAddReactionPopup
      });

      if (showAddReactionPopup) {
        // Hold off on adding the listener to avoid issue with iOS Safari where _onDocumentClick
        // could fire on same touch that opened the popup.
        setTimeout(function () {
          return document.addEventListener('click', _this._onDocumentClick);
        }, 100);
      }
    };

    _this.onToggleReaction = function (e, reaction) {
      var _this$props = _this.props,
          dispatch = _this$props.dispatch,
          feedContentId = _this$props.feedContentId,
          communityContentIdObject = _this$props.communityContentIdObject,
          logData = _this$props.logData;
      var communityContentType = communityContentIdObject.type,
          communityContentRelatedId = communityContentIdObject.relatedId,
          secondaryRelatedId = communityContentIdObject.secondaryRelatedId;


      var logDataWithFeedContentId = _extends({}, logData, _defineProperty({
        app: _logValues.WEB_APP,
        adTrackingId: _adTrackingUtil2.default.getAdTrackingIdAndSetCookie()
      }, _logValues.FEED_CONTENT_ID_KEY, feedContentId));

      // dedupe some container data
      delete logDataWithFeedContentId.container;
      delete logDataWithFeedContentId.containerType;
      delete logDataWithFeedContentId.containerSection;
      delete logDataWithFeedContentId.player;
      delete logDataWithFeedContentId.adTrackingId;

      var data = {
        logData: logDataWithFeedContentId,
        container: logData.container,
        containerType: logData.containerType,
        containerSection: logData.containerSection,
        player: logData.player,
        adTrackingId: logData.adTrackingId
      };

      if (secondaryRelatedId) {
        data.secondaryRelatedId = secondaryRelatedId;
      }

      dispatch((0, _actionCreators.toggleReactionIfNeeded)(communityContentType, communityContentRelatedId, reaction, data));
    };

    _this._onDocumentClick = function () {
      _this.setState({
        showAddReactionPopup: false
      });

      document.removeEventListener('click', _this._onDocumentClick);
    };

    _this.state = {
      showAddReactionPopup: false
    };
    return _this;
  }

  _createClass(ConnectedAddReaction, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'add-reaction' },
        this.state.showAddReactionPopup && _react2.default.createElement(_AddReactionPopup2.default, {
          currentUserReactions: this.props.currentUserReactions,
          onClickReaction: this.onToggleReaction,
          validReactions: this.props.validReactions }),
        _react2.default.createElement(_AddReactionButton2.default, {
          isBlock: this.props.isBlock,
          label: this.props.label,
          size: this.props.size,
          onOpenPopup: this.onOpenPopup })
      );
    }
  }]);

  return ConnectedAddReaction;
}(_react.Component);

ConnectedAddReaction.propTypes = {
  dispatch: _react.PropTypes.func.isRequired,
  communityContentIdObject: _react.PropTypes.object.isRequired,
  currentUserReactions: _react.PropTypes.arrayOf(_react.PropTypes.string),
  feedContentId: _react.PropTypes.string,
  isBlock: _react.PropTypes.bool,
  label: _react.PropTypes.string,
  logData: _react.PropTypes.object,
  size: _react.PropTypes.string,
  validReactions: _react.PropTypes.arrayOf(_react.PropTypes.string).isRequired
};
ConnectedAddReaction.defaultProps = {
  logData: {},
  pendingReactions: [],
  showReactionDetails: true,
  // TODO: Move validReactions to the store
  validReactions: ['fire', 'top5', '100', 'lightning', 'heart']
};


function mapStateToProps(state, ownProps) {
  var contentReactions = state.reaction.contentReactions;

  var _ref = ownProps.communityContentIdObject || {},
      communityContentType = _ref.type,
      communityContentRelatedId = _ref.relatedId;

  var communityContentIdKey = communityContentType + '-' + communityContentRelatedId;
  var reactionData = contentReactions[communityContentIdKey] || {};
  var currentUserReactions = reactionData.currentUserReactions;


  return _extends({}, ownProps, {
    currentUserReactions: currentUserReactions
  });
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(ConnectedAddReaction);